<template>
  <!-- :class="{ fixedwidth: menuStatus, trans: !menuStatus } " -->
  <div
    class="side-nav"
    :class="{ fixedwidth: menuStatus, trans: !menuStatus }"
    @mouseover="openTrainOption = true"
    @mouseleave="openTrainOption = false"
  >
    <!-- <div class="side-close pointer" v-if="menuStatus" @click="closeSideBar">
      <img src="@/assets/sidebar/img/MenuClose.svg" alt="" />
    </div> -->
    <div class="side-menu-main">
      <ul class="list-unstyled">
        <li
          class="d-flex align-items-center pointer inactivenavclass-back"
          @click="switchToCandidate('homepage')"
          @mouseenter="hoverhome = true"
          @mouseleave="hoverhome = false"
        >
          <img
            v-if="hoverhome"
            class="me-1"
            src="@/assets/sidebar/dashboardachover.svg"
            alt=""
          />
          <img
            v-else
            class="me-1"
            src="@/assets/sidebar/dashboardac.svg"
            alt=""
          />

          <span id="workBench" class="inactivenavclass ps-2">Home</span>
        </li>

        <li
          @click="switchToCandidate('dashboard')"
          class="d-flex align-items-center pointer inactivenavclass-back"
          @mouseenter="hoverBuilder = true"
          @mouseleave="hoverBuilder = false"
        >
          <img
            v-if="hoverBuilder"
            class="me-1"
            src="@/assets/sidebar/resume-builder-hover.svg"
            alt=""
          />
          <img
            v-else
            class="me-1"
            src="@/assets/sidebar/resume-builder.svg"
            alt=""
          />

          <span id="workBench" class="ps-2 inactivenavclass">
            Resume Builder</span
          >
        </li>
        <li
          @click="switchToCandidate('assessment/categories')"
          class="d-flex align-items-center pointer inactivenavclass-back"
          @mouseenter="hoverasses = true"
          @mouseleave="hoverasses = false"
        >
          <img
            v-if="hoverasses"
            class="me-1"
            src="@/assets/sidebar/asmntproginactivehover.svg"
            alt=""
          />

          <img
            v-else
            class="me-1"
            src="@/assets/sidebar/asmntproginactive.svg"
            alt=""
          />

          <span id="workBench" class="ps-2 inactivenavclass">
            Assessment Progress</span
          >
        </li>
        <li
          @click="openTrainOption = !openTrainOption"
          style="width: 93%"
          class="pointer"
        >
          <div
            class="d-flex align-items-center justify-content-between w-100 activenavclass-back"
            @mouseenter="hoverTraining = true"
            @mouseleave="hoverTraining = false"
          >
            <div class="d-flex align-items-center">
              <img
                class="me-1"
                src="@/assets/sidebar/Training-Sel.svg"
                alt=""
              />

              <span id="workBench" class="ps-2 activenavclass"> Training</span>
            </div>
            <img
              v-if="openTrainOption"
              src="@/assets/sidebar/sidebarUpArrow.svg"
              alt=""
            />
            <img v-else src="@/assets/sidebar/sidebardownarrow.svg" alt="" />
          </div>
          <b-collapse v-model="openTrainOption">
            <div class="ms-3 mt-2 ps-4">
              <div
                :class="
                  $route.name === 'MarketPlace'
                    ? 'selected-suboption'
                    : 'unselected-suboption'
                "
                @click.stop="pushPage('MarketPlace')"
                @mouseenter="hoverMarketPlace = true"
                @mouseleave="hoverMarketPlace = false"
              >
                <div v-if="hoverMarketPlace" class="sel-line-sidebar"></div>
                Market Place
              </div>
              <div
                :class="
                  $route.name === 'Dashboard'
                    ? 'selected-suboption'
                    : 'unselected-suboption'
                "
                @click.stop="pushPage('Dashboard')"
                @mouseenter="hoverMyCourse = true"
                @mouseleave="hoverMyCourse = false"
              >
                <div v-if="hoverMyCourse" class="sel-line-sidebar"></div>
                Dashboard
              </div>

              <div
                :class="
                  $route.name === 'CommunityView'
                    ? 'selected-suboption'
                    : 'unselected-suboption'
                "
                @click.stop="pushPage('CommunityView')"
                @mouseenter="hoverCommunity = true"
                @mouseleave="hoverCommunity = false"
              >
                <div v-if="hoverCommunity" class="sel-line-sidebar"></div>
                Community
              </div>
              <div
                :class="
                  $route.name === 'Certificate'
                    ? 'selected-suboption'
                    : 'unselected-suboption'
                "
                @click.stop="pushPage('Certificate')"
                @mouseenter="hoverCertificates = true"
                @mouseleave="hoverCertificates = false"
              >
                <div v-if="hoverCertificates" class="sel-line-sidebar"></div>
                Certificates
              </div>
            </div>
          </b-collapse>
        </li>
        <li
          @click="openjoboptions = !openjoboptions"
          style="width: 93%"
          class="pointer"
        >
          <div
            class="d-flex align-items-center justify-content-between w-100 inactivenavclass-back-drop"
            @mouseenter="hoverjobs = true"
            @mouseleave="hoverjobs = false"
          >
            <div class="d-flex align-items-center">
              <img
                v-if="hoverjobs"
                class="me-1"
                src="@/assets/sidebar/jobUnselhover.svg"
                alt=""
              />
              <img
                v-else
                class="me-1"
                src="@/assets/sidebar/jobUnsel.svg"
                alt=""
              />

              <span id="workBench" class="ps-2 inactivenavclass"> Jobs</span>
            </div>
            <img
              v-if="openjoboptions"
              src="@/assets/sidebar/sidebarUpArrow.svg"
              alt=""
            />
            <img v-else src="@/assets/sidebar/sidebardownarrow.svg" alt="" />
          </div>
          <b-collapse v-model="openjoboptions">
            <div class="ms-3 mt-2 ps-4">
              <div
                class="unselected-suboption"
                @click.stop="switchToCandidate('job/search')"
                @mouseenter="hoverjobsearch = true"
                @mouseleave="hoverjobsearch = false"
              >
                <div v-if="hoverjobsearch" class="sel-line-sidebar"></div>
                Job Search
              </div>
              <div
                class="unselected-suboption"
                @click.stop="switchToCandidate('job/progress?from=sidebar')"
                @mouseenter="hoverappliedjob = true"
                @mouseleave="hoverappliedjob = false"
              >
                <div v-if="hoverappliedjob" class="sel-line-sidebar"></div>
                Applied Jobs
              </div>
              <div
                class="unselected-suboption"
                @click.stop="
                  switchToCandidate('job/search?bookmarked=true&from=sidebar')
                "
                @mouseenter="hoversavedjob = true"
                @mouseleave="hoversavedjob = false"
              >
                <div v-if="hoversavedjob" class="sel-line-sidebar"></div>
                Saved Jobs
              </div>
            </div>
          </b-collapse>
        </li>
        <li
          @click="switchToCandidate('documents')"
          class="d-flex align-items-center pointer inactivenavclass-back"
          @mouseenter="hoverdoc = true"
          @mouseleave="hoverdoc = false"
        >
          <img
            v-if="hoverdoc"
            class="me-1"
            src="@/assets/sidebar/documentsinactivehover.svg"
            alt=""
          />
          <img
            v-else
            class="me-1"
            src="@/assets/sidebar/documentsinactive.svg"
            alt=""
          />

          <span id="workBench" class="ps-2 inactivenavclass">
            Upload Documents</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SideBar",
  data() {
    return {
      menu: false,
      mini: true,
      dropValue: false,
      openjoboptions: false,
      openTrainOption: false,
      title: {},
      hoverhome: false,
      hoverasses: false,
      hoverdoc: false,
      hoverBuilder: false,
      hoverjobs: false,
      hoverjobsearch: false,
      hoverappliedjob: false,
      hoversavedjob: false,
      hoverCertificates: false,
      hoverCommunity: false,
      hoverMyCourse: false,
      hoverMarketPlace: false,
      hoverTraining: false,
      baseUrl: "https://candidate.hire3x.com/builder/",
    };
  },
  watch: {
    title(value) {
      this.$store.commit("userVUEX/setPageTitle", value);
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("userVUEX", {
      menuStatus: "getMenuStatus",
    }),
  },
  methods: {
    pushPage(name) {
      this.$router.push({
        name,
      });
    },
    switchToCandidate(path) {
      window.open(this.baseUrl + path, "_self");
    },
  },
};
</script>

<style>
.activenavclass-back {
  border-radius: 8px;
  padding: 7px 8px;
}

.activenavclass-back:hover {
  background-color: #eef3f7;
}
.side-menu-main {
  padding: 0 13px;
  overflow: hidden;
}

.side-menu-main ul li {
  margin: 15px 0 0 0;
  white-space: nowrap;
  position: relative;
}
.side-nav {
  position: fixed;
  top: 60px;
  left: 0;
  background: #fcfcfc;
  width: 60px;
  border-radius: 0px;
  height: calc(100vh - 60px);
  box-shadow: 0px -2px 30px rgba(63, 105, 142, 0.25);
  z-index: 15;
  overflow: hidden;
}

.side-nav:hover {
  width: 252px;
  overflow-y: auto;
  overflow-x: hidden;
}

.side-nav:hover .side-menu-main ul li h6 {
  visibility: visible;
  transition-delay: 0.5s;
}
.activenavclass {
  color: #20639b !important;
  font-size: 16px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}
.inactivenavclass {
  color: #324054 !important;
  font-size: 16px;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
}

.inactivenavclass-back-drop {
  border-radius: 8px;
  padding: 7px 8px;
}

.inactivenavclass-back-drop:hover {
  background-color: #eef3f7;
}

.activenavclass-back {
  border-radius: 8px;
  padding: 7px 8px;
}

.activenavclass-back:hover {
  background-color: #eef3f7;
}

.inactivenavclass-back {
  border-radius: 8px;
  padding: 7px 8px;
}

.inactivenavclass-back:hover {
  background-color: #20639b14;
}

.unsel-svg {
  background-color: #ffffff;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fixedwidth {
  width: 245px !important;
}
.trans {
  transition: width 1s;
}
.side-close {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 30px;
  height: 30px;
  border-radius: 14px;
  left: 222px;
  top: 40%;
  background: #ffffff;
  box-shadow: 0px 2px 11px rgba(0, 0, 0, 0.25);
  z-index: 9561545454;
}

.selected-suboption {
  background: #20639b14;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #20639b;
  border-radius: 4px;
  padding: 7px 10px;
  margin: 2px 0;
  position: relative;
}

.unselected-suboption {
  background: #fcfcfc;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  border-radius: 4px;
  padding: 7px 10px;
  margin: 2px 0;
  position: relative;
}

.unselected-suboption:hover {
  background: #20639b14;
}

.sel-line-sidebar {
  position: absolute;
  height: 100%;
  background-color: #c0c0c0;
  width: 2px;
  border-radius: 4px;
  left: -18px;
  top: 0px;
}
</style>
